import { FormControlLabel, FormLabel, Radio, RadioGroup, Switch, Typography } from '@mui/material';
import Box from '@mui/material/Box';
import React from 'react';
import { EmployeeNotificationKey } from '../../../types/Employee';
import { optionRowSx, optionContentSx } from './emailNotificationSettingsStyles';
import { inputContainerStyling, inputDividerStyling } from '../../../styles/sxStyling';
import { UserSettingsCollapseKeys } from '../../../types/User';
import AccordionSection from '../../AccordionSection';

type EmployeeNotificationSettingsProps = {
  employeeNotifications: Record<string, boolean>;
  emailReminder: string;
  onEmployeeNotificationChange: (key: string, value: boolean) => void;
  onEmailReminderChange: (value: string) => void;
};

const NOTIFICATION_OPTIONS = [
  {
    key: EmployeeNotificationKey.NOTE_MENTION,
    label: 'Note Mentions',
    description: 'Receive emails when you are mentioned in a note.',
  },
  {
    key: EmployeeNotificationKey.TASK_ASSIGNED,
    label: 'Task Assignments',
    description: 'Receive emails when a task assigned to you becomes ready.',
  },
  {
    key: EmployeeNotificationKey.EVENT_ASSIGNED_EMAIL,
    label: 'Event Assignment Emails',
    description: 'Receive emails when an event assigned to you is published.',
  },
  {
    key: EmployeeNotificationKey.EVENT_ASSIGNED_TEXT,
    label: 'Event Assignment Texts',
    description: 'Receive texts when an event assigned to you is published.',
  },
];

const EmployeeNotificationSettings: React.FC<EmployeeNotificationSettingsProps> = ({
  employeeNotifications,
  emailReminder,
  onEmployeeNotificationChange,
  onEmailReminderChange,
}) => {
  return (
    <AccordionSection title="Emails" collapseId={UserSettingsCollapseKeys.USER_SETTINGS_EMAILS}>
      <Box sx={inputContainerStyling}>
        {/* LEFT: Preferences */}
        <Box sx={inputDividerStyling}>
          <FormLabel>Preferences</FormLabel>

          <Box>
            {NOTIFICATION_OPTIONS.map((option) => (
              <Box key={option.key} sx={optionRowSx}>
                <Box sx={optionContentSx}>
                  <Typography variant="body1">{option.label}</Typography>
                  <Typography variant="body2" color="textSecondary">
                    {option.description}
                  </Typography>
                </Box>

                <Switch checked={employeeNotifications[option.key] ?? true} onChange={(_, checked) => onEmployeeNotificationChange(option.key, checked)} />
              </Box>
            ))}
          </Box>
        </Box>

        {/* RIGHT: Reminders */}
        <Box sx={inputDividerStyling}>
          <FormLabel>Reminders</FormLabel>

          <RadioGroup row value={emailReminder} onChange={(_, value) => onEmailReminderChange(value)}>
            <FormControlLabel value="daily" control={<Radio />} label="Daily" />
            <FormControlLabel value="weekly" control={<Radio />} label="Weekly" />
            <FormControlLabel value="off" control={<Radio />} label="Off" />
          </RadioGroup>
        </Box>
      </Box>
    </AccordionSection>
  );
};

export default EmployeeNotificationSettings;
